import "../agreement.css";

const Privacy = () => {
    return (
        <div className="privacy-wrapper">
            <div title="Page 1">
                <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span>
                <div>
                    <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span>
                    <div>
                        <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span>
                        <p>
                            <span>개인정보처리방침</span>
                        </p>
                        <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
                        <p>
                            <span>
                                1. 개인정보의 수집 및 이용목적
                                <br />
                                주식회사 액츠는 수집한 개인정보를 다음의 목적을 위해 활용합니다. <br />
                                - 고객 문의에 대한 답변 제공 및 현황관리
                                <br />
                                - 리소스 자료 제공
                                <br />- 주식회사 액츠 서비스 안내, 이벤트, 뉴스레터 등 마케팅 활용 보유 : 개인정보 수집 및 이용에 관한
                                동의 후 2년 (회원탈퇴시 이후 1년)
                            </span>
                        </p>
                        <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
                        <p>
                            <span>
                                2. 수집하는 개인정보의 항목 및 수집방법
                                <br />
                                (1)수집항목
                                <br />
                                필수적 정보: 개인식별정보(성명, 주민등록번호 등 고유식별정보, 휴대전화번호, 주소 등) 선택적 정보: 개인식별정보 외에
                                고객이 제공한 정보 (이메일, 추천인 정보 등)
                                <br />- 동의를 거부할 권리 및 동의 거부에 따른 불이익
                                <br />- 필수 정보 수집에 대한 동의를 거부할 권리가 있습니다.
                                <br />- 필수 정보 외, 선택 정보 수집에 대한 동의를 거부할 권리가 있습니다.
                                <br />- 동의를 하지 않을 경우 문의하기 서비스가 제한될 수 있습니다.
                                <br />※ 주식회사 액츠는 이용자가 20세 미만일 경우, 서비스이용을 금지하고 있습니 다.
                                <br />
                                (만 나이로 적용되지 않으며, 성인으로 구분되는 20세 이상만 서비스 가능합니다.).
                            </span>
                        </p>
                        <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
                        <p>
                            <span>
                                (2)수집방법
                                <br />
                                주식회사 액츠는 다음과 같은 방법으로 개인정보를 수집합니다.
                                <br />- 회원가입, 문의하기(탈퇴,양도/양수 등 개별 문의), 플랫폼 관련 문의, 시더스ON(OTT 서비 스) 이용시
                                <br />- G1CASH 앱(APP) 방문 동안, 이용자가 G1CASH 앱(AP`P) 서비스 이용할 시<br />- Acts29 mall 관련 모든 서비스(구매,
                                배송지 입력 등) 이용시
                                <br />- 시더스페이 서비스 이용시
                            </span>
                        </p>
                        <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
                        <p>
                            <span>
                                3. 수집한 개인정보의 제공
                                <br />
                                주식회사 액츠는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다 만, 주식회사
                                액츠는 아래의 경우는 제3자에게 개인정보를 제공하고 있습니다.
                                <br />- 이용자들이 사전에 동의한 경우
                                <br />- (a) 거주지 국가 외의 법을 포함하는 관련 법에 의거하여, (b) 법령의 규정에 의거하거나, 수사 목적으로 법령에
                                정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우, (c) 국가 보 안 및/또는 법 집행을 목적으로 거주지 국가 밖의
                                공공기관 및 정부기관을 포함하는 공공기관 및 정부기관의 요청이 있을 시, 개인정보를 이용 또는 공개할 수 있습니다.
                                <br />
                                또한 구조조정, 합병, 매각, 합작회사, 양도, 이전 또는 (파산 또는 비슷한 절차와 관련된 것을 포함하여) 회사 전체 또는
                                일부, 자산 또는 주식에 대한 기타 처분을 하게 되는 경우 주식회 사 액츠는 개인정보를 관계법령에 따라
                                제3자에게 양도할 수 있습니다.
                                <br />- 주식회사 액츠 국내/해외 사업장 소속 임직원간 원활한 업무 추진 및 의사소
                            </span>
                        </p>
                        <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span>
                    </div>
                    <span>&nbsp; &nbsp; &nbsp; &nbsp;</span>
                    <div>
                        <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span>
                        <p>
                            <span>통이 필요한 경우</span>
                        </p>
                        <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
                        <p>
                            <span>
                                4. 수집한 개인정보의 보유
                                <br />
                                주식회사 액츠는 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 그러나 다음의
                                이유로 일정 기간 동안 해당 정보를 보유할 수도 있습니다. (1) 주식회사 액츠 정책에 따른 정보 보유
                                <br />- 항목: 1.(1)항의 수집항목
                                <br />- 사유: 이용자의 활동 이력 관리, 탈퇴 후 재가입 방지 관리 등<br />- 기간: 2년간 보유
                                <br />
                                (2) 관련 법령에 따른 정보의 보유
                                <br />
                                주식회사 액츠는 관계 법령 위반에 따른 수사 조사 등이 진행 중인 경우에는 해 당 수사 조사 종료 시까지 해당
                                법령에 따라 일정 기간 동안 정보를 보유합니다.
                            </span>
                        </p>
                        <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
                        <p>
                            <span>
                                5. 개인정보의 제3자 제공
                                <br />
                                회사는 정보주체의 동의를 통해 다음과 같이 개인정보 제3자 제공을 하고 있으며 원칙적으로 정보주체의 동의 없이는
                                제3자에게 제공하지 않습니다.
                                <br />
                                아래의 경우에 개인정보 위탁이 가능 합니다.
                                <br />- 이용자들이 사전에 동의한 경우
                                <br />- 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사 기관의 요구가 있는 경우
                            </span>
                        </p>
                        <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
                        <p>
                            <span>
                                6. 개인정보의 안전성 확보 조치
                                <br />
                                주식회사 액츠는 다음과 같이 안전성 확보에 필요한 기술적, 관리적, 물리적 조 치를 하고 있습니다.
                            </span>
                        </p>
                        <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
                        <p>
                            <span>
                                개인정보 처리 담당자의 최소화 및 교육
                                <br />
                                개인정보를 처리하는 담당자를 지정하고 최소화하여 개인정보를 관리하는 대책을 시행하고 있 습니다.
                            </span>
                        </p>
                        <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
                        <p>
                            <span>
                                개인정보에 대한 접근 제한
                                <br />
                                개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여, 변경, 말소를 통하여 개인 정보에 대한 접근통제를 위하여
                                필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부 로부터의 무단 접근을 통제하고 있습니다.
                            </span>
                        </p>
                        <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
                        <p>
                            <span>
                                접속기록의 보관 및 위변조 방지
                                <br />
                                개인정보처리시스템에 접속한 기록(웹 로그, 요약정보 등)을 최소 6개월 이상 보관, 관리하고 있으며, 접속 기록이 위변조 및
                                도난, 분실되지 않도록 보안기능을 사용하고 있습니다.
                            </span>
                        </p>
                        <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
                        <p>
                            <span>
                                해킹 등에 대비한 기술적 대책
                                <br />
                                주식회사 액츠는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을
                                설치하고 주기적인 갱신&middot;점검을 하며 외부로부터 접근이 통제된
                            </span>
                        </p>
                        <div>
                            <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span>
                            <div>
                                <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span>
                                <p>
                                    <span>
                                        구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다. 또한 네트워크 트 래픽의
                                        통제(Monitoring)는 물론 불법적으로 정보를 변경하는 등의 시도를 탐지하고 있습니 다.
                                    </span>
                                </p>
                                <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span>
                            </div>
                            <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span>
                        </div>
                        <span>&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span>
                    </div>
                </div>
            </div>
            <div title="Page 2">
                <span>
                    <br />
                </span>
            </div>
            <p>
                <span>&nbsp; &nbsp; </span>
            </p>
            <div title="Page 3">
                <br />
            </div>
        </div>
    );
};

export default Privacy;
